import { OnlineStatusText, OnlineStatusTextProps } from '@cp/ds/src/components/onlineStatus';
import React, { useMemo } from 'react';
import { format } from 'date-fns';
import { DateFormat } from '@common/const/date';
import { FormattingStrategy, HasOnlineStatus, getLastSeenText, isOnline, timeToDistance } from '../model';

export interface ClientLastSeenProps extends Partial<OnlineStatusTextProps> {
  profile: HasOnlineStatus;
  strategy?: FormattingStrategy;
  online?: boolean;
  now?: Date;
}

export const ClientLastSeenText: React.FC<ClientLastSeenProps> = ({
  profile,
  online,
  strategy = timeToDistance,
  now = new Date(),
  ...props
}) => {
  const calculatedOnline = typeof online === 'undefined' ? isOnline(profile) : online;
  const statusText = useMemo(
    () => getLastSeenText({ ...profile, isOnline: calculatedOnline }, strategy, now),
    [calculatedOnline, profile, strategy, now],
  );

  const activityDate = useMemo(
    () => (profile.lastActivityAt ? format(new Date(profile.lastActivityAt), DateFormat.DateTimeISO) : ''),
    [profile.lastActivityAt],
  );

  return (
    <OnlineStatusText {...props} component="time" datetime={activityDate} online={calculatedOnline}>
      {statusText}
    </OnlineStatusText>
  );
};
